module.exports = __webpack_public_path__ + "img/12.a6ce0e6.svg";